module.exports = __webpack_public_path__ + "static/media/kendrafoundit-ig-2.d84285d5.PNG";